import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
import {
  endOfDay,
  addMonths, format, startOfHour, addHours, addMinutes, startOfMinute
} from 'date-fns';
import {
  DAYS_IN_WEEK,
  SchedulerViewDay,
  SchedulerViewHour,
  SchedulerViewHourSegment,
  CalendarSchedulerEvent,
  CalendarSchedulerEventAction,
  startOfPeriod,
  endOfPeriod,
  addPeriod,
  subPeriod,
  SchedulerDateFormatter,
  SchedulerEventTimesChangedEvent,
  CalendarSchedulerViewComponent
} from 'angular-calendar-scheduler';
import {
  CalendarView,
  CalendarDateFormatter,
  DateAdapter
} from 'angular-calendar';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
/**
 * This component is doctor can schedule appointment to patient.
 * Doctor can fill the patient information and schedule the appointment.
 */
@Component({
  selector: 'app-appointment-by-doctor',
  templateUrl: './appointment-by-doctor.component.html',
  styleUrls: ['./appointment-by-doctor.component.css'],
  providers: [{
    provide: CalendarDateFormatter,
    useClass: SchedulerDateFormatter
  }]
})
export class AppointmentByDoctorComponent implements OnInit {
  @ViewChild('msg')modalref:any
  todayDate = new Date();
  startAt:Date; 
  endAt: Date;
  requestForm = this.fb.group({
    appointmentId: new FormControl(''),
    detailsDto: this.fb.group({
      id: '0',
      firstName: new FormControl("", Validators.required),
      lastName: new FormControl("", Validators.required),
      dob: new FormControl("", Validators.required),
      genderId: new FormControl(null, Validators.required),
      relation: new FormControl(null),
      toWhom:new FormControl('MYSELF'),
      phoneNumber: new FormControl("", Validators.required),
      email: new FormControl("", [Validators.required , Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')])
    }),
    appointmentDate: new FormControl("", Validators.required),
    appointmentTime: new FormControl(""),
    modeOfConsultation: new FormControl("", Validators.required),
    additionalInfo: new FormControl(),
    service: new FormControl("")
  });
  typeMode: any;
  gender: any
  fileName: any;
  acceptFilesFormat = ".pdf,.doc,.docx,.jpeg,.jpg,.png"
  //Event Calendar 
  CalendarView = CalendarView;
  view: CalendarView = CalendarView.Week;
  viewDate: Date = new Date();
  viewDays: number = 7;
  refresh: Subject<any> = new Subject();
  locale: string = 'en';
  hourSegments: number = 2;
  weekStartsOn: number = 1;
  startsWithToday: boolean = true;
  activeDayIsOpen: boolean = true;
  excludeDays: number[] = []; // [0];
  dayStartHour: number =0;
  dayEndHour: number =24;
  minDate: Date = new Date();
  maxDate: Date = endOfDay(addMonths(new Date(), 2));
  dayModifier: Function;
  hourModifier: Function;
  segmentModifier: Function;
  eventModifier: Function;
  prevBtnDisabled: boolean = false;
  nextBtnDisabled: boolean = false;
  count = 0

  events: CalendarSchedulerEvent[] = [];

  @ViewChild(CalendarSchedulerViewComponent) calendarScheduler: CalendarSchedulerViewComponent;
  actions: CalendarSchedulerEventAction[] = [
    {
      when: 'enabled',
      label: '<span class="valign-center"><i class="bi bi-x-circle-fill  iconClr"></i>Delete</span>',
      title: 'Delete',
      onClick: (event: CalendarSchedulerEvent): void => {
        this.events = this.events.filter(item => item.title !== event.title);
        this.count = 0
        this.refresh.next()
        this.requestForm.get('appointmentDate').patchValue("");
      }
    },
    {
      when: 'cancelled',
      label: '<span class="valign-center"><i class="material-icons md-18 md-red-500">autorenew</i></span>',
      title: 'Restore',
      onClick: (event: CalendarSchedulerEvent): void => {
        // console.log('Pressed action \'Restore\' on event ' + event.id);
      }
    }
  ];
  maxdate: Date;

  constructor(public doctorService: TalkToDoctorService, public fb: FormBuilder, public router: Router,public modalService: BsModalService,private dateAdapter: DateAdapter) 
  {
    this.dayModifier = ((day: SchedulerViewDay): void => {
      day.cssClass = this.isDateValid(day.date) ? '' : 'cal-disabled';
    }).bind(this);

    // this.hourModifier = ((hour: SchedulerViewHour): void => {
    //   hour.cssClass = this.isDateValid(hour.date) ? '' : 'cal-disabled';
    // }).bind(this);

    this.segmentModifier = ((segment: SchedulerViewHourSegment): void => {
      segment.isDisabled = !this.isDateValid(segment.date);
    }).bind(this);

    this.eventModifier = ((event: CalendarSchedulerEvent): void => {
      event.isDisabled = !this.isDateValid(event.start);
    }).bind(this);

    this.dateOrViewChanged();

   }

  ngOnInit(): void {
    // this.startAt = new Date(new Date().setHours(6,0,0));
    // this.endAt = new Date(new Date().setHours(22,0,0))
    // const roundToHalf = date => new Date(Math.ceil(date / (1000 * 60 * 30)) * (1000 * 60 * 30))
    // this.todayDate =roundToHalf(new Date);
    // (this.startAt >= this.todayDate)? this.todayDate=this.startAt:this.startAt=this.todayDate;
    let date =new Date()
    this.maxdate = new Date(`${date.getMonth()+1}-${date.getDate()}-${date.getFullYear()-18}`);
    this.doctorService.getGender().subscribe(gender$ => {
      this.gender = gender$;
    });

    this.getSchedular(this.viewDate);

  }

  async getSchedular(date) {
    this.events = []
    let finalDate = new Date().setDate(date.getDate() + 6);
    let obj = {
      fromDate: format(date, 'dd-MM-yyyy'),
      endDate: format(finalDate, 'dd-MM-yyyy'),
      doctorId: 0
    };
    this.doctorService.DoctorBookingScheduler(obj).subscribe(async data => {
      let getdata: any = data;
      this.dayEndHour =getdata.availabilityEndTime;
      this.dayStartHour =getdata.availabilityStartTime;
      this.refresh.next();
      await getdata.calenderEvents.forEach(ele => {
        let eventData: CalendarSchedulerEvent = {
          id: ele.id,
          start: startOfMinute(new Date(ele.start)),
          //end: addMinutes(startOfHour(addHours(new Date(1628506217195), 0)), 29),
          end: addMinutes(startOfMinute(new Date(ele.end)), ele.interval),
          title: ele.title,
          content: ele.content,
          color: ele.color,
          actions: this.actions,
          // status: 'ok' as CalendarSchedulerEventStatus,
          isClickable: ele.clickable,
          isDisabled: ele.disabled
        }
        this.events.push(eventData);
      });
      this.refresh.next();
    });
  }


  fileUpload(event: any) {
    if (event.target.files.length) {
      for (let file in event.target.files) {
        if (!isNaN(Number(file))) {
          let currentFile = event.target.files[file]
          let fileExtension = currentFile.name.substring(currentFile.name.lastIndexOf(".")).toLowerCase();
          let acceptedFilesArray = this.acceptFilesFormat.toLowerCase().split(",");
          if (acceptedFilesArray.indexOf(".") === -1 && acceptedFilesArray.indexOf(fileExtension) === -1) {
            Swal.fire({
              title: `Unsupported File`,
              icon: 'info',
            })
          } else if (currentFile.size > 2097152) {
            Swal.fire({
              title: `Upload file size should not exceed 2MB `,
              icon: 'info',
            })
          } else{
            this.fileName.push(event.target.files[file])
          }
        }
      };
    }

  }

  removeFile(file) {
    let index = this.fileName.indexOf(file);
    if(index > -1){
         this.fileName.splice(index,1);
    }
    return this.fileName
  }


  async submitReq_Form() {
    if (!this.requestForm.valid) {
      this.requestForm.markAllAsTouched();
      return false;
    } else {
      let date: any = this.requestForm.get('appointmentDate').value;
      if (date) {
        this.requestForm.get('appointmentTime').patchValue(date);
      }
      let reqAppoinment = this.requestForm.value;
      this.doctorService.createAppointmentToMember(reqAppoinment).subscribe((res:any)=> {
        if (res.status == 'true') {
          this.router.navigate(['/doctorappoinment-list'])
        }else{
          this.modalService.show(this.modalref, {
            class: 'mymodal1',
            initialState:{ message:res.message}
            
          });
        }
      }, err => {
    
      });
    }
  };
  getValues(data: any) {
    if (data.mode) {
      this.typeMode = data.mode;
      this.requestForm.get('modeOfConsultation').patchValue(data.mode);
    } else if (data.doctorId) {
      this.requestForm.get('doctorId').patchValue(data.doctorId)
    }
  }

  openModal(temp) {
    this.modalService.show(temp, {
      class: 'mymodal'
    });
  };

//Events

viewDaysOptionChanged(viewDays: number): void {

  this.calendarScheduler.setViewDays(viewDays);
}

changeDate(date: Date): void {
  this.viewDate = date;
  this.dateOrViewChanged();
}

changeView(view: CalendarView): void {
  this.view = view;
  this.dateOrViewChanged();
}

dateOrViewChanged(): void {
  if (this.startsWithToday) {
    this.prevBtnDisabled = !this.isDateValid(subPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1));
    this.nextBtnDisabled = !this.isDateValid(addPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1));
  } else {
    this.prevBtnDisabled = !this.isDateValid(endOfPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, subPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1)));
    this.nextBtnDisabled = !this.isDateValid(startOfPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, addPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1)));
  }

  if (this.viewDate < this.minDate) {
    this.changeDate(this.minDate);
  } else if (this.viewDate > this.maxDate) {
    this.changeDate(this.maxDate);
  }
}

private isDateValid(date: Date): boolean {
  return /*isToday(date) ||*/ date >= this.minDate && date <= this.maxDate;
}

viewDaysChanged(viewDays: number): void {
  
  this.viewDays = viewDays;
}

dayHeaderClicked(day: SchedulerViewDay): void {
  // console.log('dayHeaderClicked Day', day);
}

// hourClicked(hour: SchedulerViewHour): void {
//   console.log('hourClicked Hour', hour);
// }

segmentClicked(action: string, segment: SchedulerViewHourSegment): void {
  this.count++;
  if (this.count == 1) {
    this.requestForm.get('appointmentDate').patchValue(segment.date);
    segment.backgroundColor = '#e8fde7';
    segment.isDisabled = true;
    let eventData: CalendarSchedulerEvent = {
      id: "",
      start: startOfMinute(new Date(segment.date)),
      color: { primary: '#e8fde7', secondary: '#e8fde7' },
      title: "",
      actions: this.actions,
      isClickable: true,
    }
    this.events.push(eventData);
    this.refresh.next();
    this.modalService.hide();
  }
}

eventClicked(action: string, event: CalendarSchedulerEvent): void {
  // console.log('eventClicked Action', action);
  // console.log('eventClicked Event', event);
}

eventTimesChanged({ event, newStart, newEnd, type }: SchedulerEventTimesChangedEvent): void {
  const ev: CalendarSchedulerEvent = this.events.find(e => e.id === event.id);
  ev.start = newStart;
  ev.end = newEnd;
  this.refresh.next();
}




}
